<div class="container-fluid sticky">
  <nav class="navbar navbar-expand-xl py-0 w-100">
    <div class="row top-bar justify-content-center">
      <div class="col-10 px-0">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <i class="fas fa-bars menu-icon"></i>
        </button>
        <span class="logo-text-mobile d-xl-none" [routerLink]="['/home']">Mums & Midwives</span>
      </div>
    </div>
    <!-- Navigation bar Starts -->
    <div class="navbar-custom">
      <!-- Navigation bar is splitted -->
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <div class="row justify-content-center">
          <div class="col-10 pl-5">
            <ul class="navbar-nav mr-auto d-xl-none">
              <li *ngIf="authService.token">
                <span class="navbar-item-text" [routerLink]="['/dashboard']">Dashboard</span>
              </li>
              <li>
                <span class="navbar-item-text" [routerLink]="['/search-listing']">Search By Region</span>
              </li>
              <li>
                <span class="navbar-item-text">How I Choose</span>
              </li>
              <li>
                <span class="navbar-item-text">News & articles</span>
              </li>
              <li>
                <span class="navbar-item-text">Shop</span>
              </li>
              <li>
                <span class="navbar-item-text">Contact</span>
              </li>
            </ul>
            <div *ngIf="!authService.token" class="d-flex ml-3 my-3 d-xl-none">
              <button class="btn btn-theme-inverse mr-3 right-aligned" data-toggle="modal"
                data-target="#login-modal">Login</button>
              <button class="btn btn-theme" [matMenuTriggerFor]="signupMenu">Signup <i
                  class="ml-1 fas fa-chevron-down"></i></button>
            </div>
            <div *ngIf="authService.token" class="d-flex ml-3 my-3 d-xl-none">
              <button class="btn btn-theme-inverse right-aligned" (click)="logout()">Logout</button>
            </div>
          </div>
        </div>
      </div>
      <div class="row d-none d-xl-block mr-0">
        <div class="col-10 offset-1">
          <div class="d-flex flex-row justify-content-between">
            <!-- Logo Starts -->
            <div class="header-title-container">
              <span class="logo-text" [routerLink]="['/home']">Mums &<br> Midwives</span>
            </div>
            <!-- Logo Ends -->

            <!-- Menu Item Section and Buttons Starts -->
            <div class="d-flex flex-column nav-container">
              <div *ngIf="!authService.token" class="d-flex flex-row-reverse">
                <button class="btn btn-theme right-aligned mr-3" [matMenuTriggerFor]="signupMenu">Signup <i
                    class="ml-1 fas fa-chevron-down"></i></button>
                <button class="btn btn-theme-inverse mr-3 right-aligned" data-toggle="modal"
                  data-target="#login-modal">Login</button>
              </div>
              <div *ngIf="authService.token" class="d-flex flex-row-reverse">
                <button class="btn btn-theme-inverse right-aligned mr-3" (click)="logout()">Logout</button>
              </div>
              <ul class="topnav-menu mt-4" id="navigation">
                <li *ngIf="authService.token">
                  <span class="navbar-item-text" [routerLink]="['/dashboard']">Dashboard</span>
                </li>
                <li *ngIf="isLoggedInUserMum">
                  <span class="navbar-item-text" [routerLink]="['/search-listing']">Search By Region</span>
                </li>
                <li>
                  <span class="navbar-item-text">How I Choose</span>
                </li>
                <li>
                  <span class="navbar-item-text">News & articles</span>
                </li>
                <li>
                  <span class="navbar-item-text">Shop</span>
                </li>
                <li>
                  <span class="navbar-item-text">Contact</span>
                </li>
              </ul>
            </div>
            <!-- Menu Item Section and Buttons Starts -->
          </div>
        </div>
      </div>
      <!-- Navigation bar is splitted -->
    </div>
    <!-- Navigation bar Ends -->
  </nav>
  <!-- </div> -->
</div>

<!--Signup Modal Starts-->
<app-sign-up (otpVerfication)='setOtpData($event)'></app-sign-up>
<!--Signup Modal Ends-->

<!--Login Modal Starts-->
<app-login (passwordOtp)='setEmail($event)'></app-login>
<!--Login Modal Ends-->

<!--Forgot Password Modal Starts-->
<app-forgot-password [otpData]="otpData" [user]="user"></app-forgot-password>
<!--Forgot Password Modal Ends-->

<mat-menu #signupMenu="matMenu">
  <span class="dropdown-item" data-toggle="modal" data-target="#signup-modal-pregnant">Are you pregnant
    ?</span>
  <span class="dropdown-item" data-toggle="modal" data-target="#signup-modal-midwife-1">Are you a midwife
    ?</span>
</mat-menu>